<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="verfinanzas" multiple>
                    <v-expansion-panel class="active-class">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Pendientes</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <br />
                            <DataTable :url="url"
                                       :columns="head"
                                       :order="[[0, 'desc']]"
                                       @apiDT="apiDT = $event">
                            </DataTable>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import General from "@/services/Operacion/Operacion.service.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                verfinanzas: [0],
                showcargando: true,
                apiDT: null,
                url: "Operacion/PendientesPoderes",
                head: [
                    { name: "podnumescritura", data: "podnumescritura", title: "N° de Escritura", },
                    { name: "podnumcopia", data: "podnumcopia", title: "N° de Copia" },
                    { name: "nrreporte", data: "nrreporte", title: "N° de Reporte" },
                    { name: "svindice", data: "svindice", title: "N° de Indice" },
                    { name: "svfhreporte", data: "svfhreporte", title: "Fecha de Reporte" },
                    { name: "exfechaabo", data: "exfechaabo", title: "Fecha de Acreditación" },
                    { name: "prnombre", data: "prnombre", title: "Responsable" },
                    { name: "tiempo", data: "tiempo", title: "Días de Préstamo" },
                ],
            }
        },
        methods: {
            reloadTable() {

                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        mounted() {
            
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '275').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>
<style scoped>
    .title-card-style {
        padding: 1.5px !important;
        max-height: auto;
    }

    .card-title-text {
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 1em;
        color: white;
    }
</style>